import React from "react" 

import {Navbar2} from "./components/Navbar" 

import dataInfo from "./data.js"




export default function ProjOpengl() 
{
    let projInfo = dataInfo[0];

    for (let i=0; i<dataInfo.length; i++)
    {
        if(dataInfo.at(i).id == 4)
        {
            projInfo = dataInfo.at(i);
            break;
        }
    }

    // console.log("projInfo: ", projInfo)

    const bullets = projInfo.bullets.split(";").map(bullet => bullet.trim());

    const BulletElement = bullets.map((bullet, index) => 
                        {
                            return( 
                            <li key={index} >  {bullet}  </li> 
                             );
                        } );


    return ( 
        <div>
            <Navbar2/>

            <div class="aboutContainer">

                <div class="aboutLeft">
                {/* width="560" height="315" */}
                <iframe 
                width="560" height="315" src="https://www.youtube.com/embed/aZlX9q77rwY?si=VmFq3zMi1hJVb9zT" 
                title="Orbitarium" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>

                </iframe>

                {/* <img src={orrery} alt="Orrery Image" /> */}
                </div>

                <div class="aboutRight">

                        <h1 >
                            {projInfo.title}
                        </h1>

                        <p>
                        {projInfo.description.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                    <br />
                                </React.Fragment>
                            ))}

                            {/* {projInfo.description} */}
                        </p>

                        <ul>
                            {BulletElement}
                        </ul>

                        {
                            projInfo.downloadLink!="" ? 
                            <a className="skillTab" href={projInfo.downloadLink}  download={projInfo.downloadName} >
                            Download the application
                            </a> : null
                        }

                        {
                            projInfo.liveDemoLink!="" ? 
                            <a className="skillTab" href={projInfo.liveDemoLink}  target="_blank" >
                            Live Demo
                            </a> : null
                        }

                        {
                            projInfo.githubLink!="" ? 
                            <a className="skillTab" href={projInfo.githubLink}  target="_blank">
                            Github link
                            </a> : null
                        }

                            <a className="skillTab" href="https://www.spaceappschallenge.org/nasa-space-apps-2024/find-a-team/exhausky/"  target="_blank">
                            Official Submission
                            </a>
                        

                </div>
             </div>

        </div>
    )
}

